import * as React from 'react';
import debounce from 'lodash.debounce';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import {
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TextField,
  TableHead,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import styles from './Grid.module.styl';

const SEARCH_DEBOUNCE = 1000;
/**
 * DISCLAIMER: This component has been migrated from js file
 * Therefore there are so many 'any' types.
 * Please feel free to refactor it.
 */
class GridNew extends React.Component<any, any> {
  private readonly applySearch: any;

  public constructor(props: any) {
    super(props);

    const { onSearch, searchPhrase } = props;

    const decodedSearchPhraseFromUrl = decodeURI(searchPhrase);

    this.state = {
      search: decodedSearchPhraseFromUrl || '',
    };

    this.applySearch = onSearch ? debounce(onSearch, SEARCH_DEBOUNCE) : null;
  }

  public handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number,
  ) => {
    const {
      pagination,
      history,
      location: { search },
      urlPrefix,
      searchPhrase,
      onFilterReset,
    } = this.props;

    if (onFilterReset) {
      onFilterReset();
    }

    const parsedSearch = qs.parse(search.slice(1));
    parsedSearch.page = newPage;
    parsedSearch.limit = pagination.limit;

    history.push(
      `${urlPrefix}?${qs.stringify(parsedSearch)}${
        searchPhrase ? `#${searchPhrase}` : ''
      }`,
    );
  };

  public handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const {
      history,
      urlPrefix,
      searchPhrase,
      onFilterReset,
      location: { search },
    } = this.props;
    const initialPage = 0;

    if (onFilterReset) {
      onFilterReset();
    }

    const parsedSearch = qs.parse(search.slice(1));
    parsedSearch.page = initialPage;
    parsedSearch.limit = event.target.value;

    history.push(
      `${urlPrefix}?${qs.stringify(parsedSearch)}${
        searchPhrase ? `#${searchPhrase}` : ''
      }`,
    );
  };

  public onSearchChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
  ) => {
    const { onFilterReset } = this.props;

    if (onFilterReset) {
      onFilterReset();
    }

    this.setState(
      {
        search: e.target.value,
      },
      () => {
        const { search } = this.state;
        if (this.applySearch) {
          this.applySearch.cancel();
          this.applySearch(search);
        }
        if (this.props.onFilterReset) {
          this.props.onFilterReset();
        }
      },
    );
  };

  public render() {
    const {
      data,
      config,
      history,
      urlPrefix,
      removeItem,
      pagination,
      location: { search, hash },
      onSearch,
    } = this.props;

    const { search: searchPhrase } = this.state;

    return (
      <div>
        <div className={styles.topBar}>
          <Typography variant="h4" id="tableTitle">
            {config.title}
          </Typography>
          {onSearch && (
            <div className={styles.filtersBar}>
              {this.props.filterPanelIcon && this.props.filterPanelIcon()}
              <TextField
                placeholder="Search"
                margin="dense"
                onChange={this.onSearchChange}
                variant="outlined"
                className={styles.search}
                value={searchPhrase}
              />
            </div>
          )}
        </div>
        {this.props.filterPanel && this.props.filterPanel()}
        <Table>
          <TableHead>
            <TableRow>
              {config.columns.map((column: any) => (
                <TableCell key={column.name} component="th" scope="row">
                  {column.title}
                </TableCell>
              ))}
              <TableCell component="th" scope="row" />
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item: any) => {
              const handleEditClick = () =>
                history.push(`${urlPrefix}/${item.id}${search}${hash}`);
              const handleDeleteClick = () => removeItem(item.id);

              return (
                <TableRow hover={true} role="checkbox" key={item.id}>
                  {config.columns.map((column: any) => (
                    <TableCell key={column.name} component="td" scope="row">
                      {column.component ? (
                        <column.component
                          {...column}
                          value={item[column.name]}
                        />
                      ) : (
                        item[column.name]
                      )}
                    </TableCell>
                  ))}
                  <TableCell
                    align="right"
                    style={{
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <IconButton aria-label="Edit" onClick={handleEditClick}>
                      <EditIcon />
                    </IconButton>

                    {typeof removeItem === 'function' && (
                      <IconButton
                        aria-label="Delete"
                        onClick={handleDeleteClick}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {pagination && (
          <TablePagination
            component="div"
            count={pagination.total}
            rowsPerPage={pagination.limit}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        )}
      </div>
    );
  }
}

export default withRouter(GridNew);
